export interface ProgressBarConfig {
    id?: string;
    type?: string;
    progressValue?: number;
}

export const DEFAULT_PROGRESS_BAR_CONFIG: ProgressBarConfig = {
    id: '',
    type: '',
    progressValue: 0
};